<template>
<div>
    <div class="row">
        <div class="col-md-3 mb-3">
            <button class="btn btn-outline-primary" @click="openFilterModal"><i class="fas fa-search"></i> Filtrar Datas</button>
        </div>
    </div>
    <div class="row">
        <div class="col-md-3 mb-3">
            <info-card :title="'Total de Entradas'" icon="fa-arrow-up" variant="success" :value="openBillReceivebleTotal.sum_due_value" />
        </div>
        <div class="col-md-3 mb-3">
            <info-card :title="'Total de Saídas'" icon="fa-arrow-down" variant="danger" :value="openBillReceivebleTotal.sum_due_value" />
        </div>
    </div>
    <br />
    <div class="row">
        <div class="col-md-6 mb-12">
            <payment-methods-chart />

        </div>
    </div>
    <br />
    <dashboard-filter ref="dashboardFilter" />

    <error-handler :error="error" />
</div>
</template>

<script>
import TablePaginator from "./../sections/TablePaginator.vue";
import InfoCard from "./../sections/dashboard/InfoCard.vue";
import AppBarChart from "./../ui/AppBarChart.vue";
import OrderHistoricChart from "./../charts/OrderHistoricChart.vue";
import Filter from "./../../mixins/Filters";
import Avatar from "vue-avatar";
import DashboardFilter from "./../Filter/DashboardFilter.vue"
import PaymentMethodsChart from "./../charts/PaymentMethodsChart.vue"

export default {
    components: {
        InfoCard,
        AppBarChart,
        OrderHistoricChart,
        Avatar,
        DashboardFilter,
        PaymentMethodsChart
    },

    data: function () {
        return {

            todayOrderTotal: {},

            monthOrderTotal: {},

            accounts: {},

            accountsBalance: {},

            openBillReceivebleTotal: {},

            error: null,

            orderTotalByMonth: []
        };
    },

    created() {
        axios
            .post("api/dashboard/select", this.searchForm)
            .then(response => {
                // this.items.Dia = response.data.todayOrderTotal;
                this.monthOrderTotal = response.data.monthOrderTotal;
                this.accounts = response.data.accounts;
                this.accountsBalance = response.data.accountsBalance;
                this.openBillReceivebleTotal = response.data.openBillReceivebleTotal;
                this.orderBySalesman = response.data.orderBySalesman;
                // this.accountTransactionsIn   = response.data.accountTransactionsIn;
                this.orderTotalByMonth = response.data.orderTotalByMonth;

                this.$store.commit("pageHasLoaded");
            })
            .catch(error => {
                this.error = error;
                this.$store.commit("pageHasLoadedWithError", {
                    error: error
                });
            });
    },

    computed: {

    },

    methods: {
        openFilterModal() {
            this.$refs.dashboardFilter.open();
        },
    }


};
</script>

<style>
</style>
